import apiClient from '../../../common/functions/api_axios_instance.function';

export const updateSystemPoAuthorizedRecord = async (id, payload) => {
  try {
    const response = await apiClient.patch(
      `/systemInvoiceManagement/purchaseOrderManagement/authorized-records/${id}`,
      payload
    );
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'PO updated successfully',
      };
    }
    return {
      success: false,
      status: response.status,
      error: response.data?.message || response.data?.error || 'Failed to update PO',
    };
  } catch (error) {
    return {
      success: false,
      status: error?.response?.status,
      error:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to update PO',
    };
  }
};
